<template>
    <DefPicture
        v-if="isIphone && result.desktop"
        :result="result"
    />
    <DefImg
        v-else-if="isIphone"
        :result="result"
        class="def-video"
    />
    <video
        v-else
        ref="element"
        class="def-video"
        v-bind="getVideo"
        :muted="muted"
    ></video>
</template>
<!--controls-->
<script>
import DefPicture from "../DefPicture/DefPicture.vue";
import DefImg from "../DefImg/DefImg.vue";

export default {
    name: 'DefVideo',
  components: {DefImg, DefPicture},
    props: {
        result: {
            type: Object
        },
        muted: {
            type: Boolean,
            default: true,
        }
    },
    data() {
        return {
            intersectionObserver: null,
            isShow: false,
            options: {
                rootMargin: '10px',
                threshold: .01,
            },
        }
    },
    computed: {
        getVideo() {
            return this.result?.[ this.getDeviceName ] ?? this.result;
        },
        isIphone() {
            return /^(iPhone|iPad|iPod)/.test(navigator.platform);
        }
    },
    methods: {
        observerCallBack (entries) {
            try {
                // If intersectionRatio is 0, the target is out of view
                // and we do not need to do anything.

                if (entries[0].intersectionRatio <= 0) {
                    // this.isShow = false;
                    // this.$refs.element.pause();
                    return;
                }
                this.isShow = true;
                this.$refs?.element?.play();
                // this.intersectionObserver.unobserve(this.$refs.element);
            } catch (err) {
                console.error(err);
            }
        },
    },
    mounted() {
        try {
            const element = this.$refs.element;
            if (this.result && !this.intersectionObserver && element) {
                if ('IntersectionObserver' in window) {
                    // LazyLoad images using IntersectionObserver
                    this.intersectionObserver = new IntersectionObserver(this.observerCallBack, this.options);
                    this.intersectionObserver.observe(element);
                } else {
                    // Load all images at once
                    this.isShow = true;
                }
            }
        } catch (err) {
            console.error(err);
        }
    },
    beforeUnmount() {
        try {
            if (
                'IntersectionObserver' in window &&
                this.result &&
                this.intersectionObserver
            ) {
                this.intersectionObserver.unobserve(this.$refs.element);
            }
        } catch (err) {
            console.error(err);
        }
    }
}
</script>

<style lang="scss" scoped>
.def-video{
    max-width: 100%;
    height: auto;
}
</style>